<template>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title>
        <h4>FOTOS DEL PRODUCTO</h4>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        dark
        fab
        small
        icon
        @click="abrirDialogNuevaFotoProducto"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :headers="headers"
          :items="fotosProducto"
          hide-actions
          class="elevation-0"
          :loading="loadingFotosProducto"
        >
          <template slot="items" slot-scope="props">
            <td class="text-lg-center">
              <v-icon :color="props.item.codigoHtml" medium>widgets</v-icon>
            </td>
            <td>{{ props.item.nombreColor }}</td>
            <td>
              <v-avatar size="128px" class="mx-auto d-block">
                <img
                  :src="$store.state.apiHost + props.item.urlFotoThumb"
                  :alt="props.item.descripcionProducto"
                />
              </v-avatar>
            </td>
            <td class="text-xs-right">
              <v-btn
                flat
                icon
                color="grey"
                @click="
                  getProductoFoto(props.item.productoId, props.item.colorId)
                "
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                flat
                icon
                color="grey"
                :loading="$store.state.loadingDelete.show"
                @click="
                  deleteProductoFoto(props.item.productoId, props.item.colorId)
                "
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
    <form-producto-foto
      :fotoProducto="fotoProducto"
      @onFotoProductoAdded="onFotoProductoAdded"
      @onFotoProductoUpdated="onFotoProductoUpdated"
      ref="dialogFotoProducto"
    ></form-producto-foto>
    <confirm ref="confirm"></confirm>
  </v-card>
</template>

<script>
//Components
import confirm from "@/components/dialogs/Confirm";
import formProductoFoto from "./FormFotoProducto";

//Sevices
import fotoProductoService from "@/services/fotoProductoService";

export default {
  components: {
    formProductoFoto,
    confirm,
  },
  props: {
    producto: {
      type: Object,
    },
  },
  watch: {
    producto: function (newProducto) {
      this.extraerFotos();
      this.fotoProducto.productoId = newProducto.productoId;
    },
  },
  data() {
    return {
      headers: [
        { text: "", align: "center", sortable: false, value: "codigoHtml" },
        { text: "COLOR", align: "center", value: "nombreColor" },
        { text: "FOTO", align: "center", value: "urlFotoThumb" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      fotosProducto: [],
      fotoProducto: {
        productoId: this.producto.productoId,
        colorId: 0,
        urlFotoThumb: "/Content/FotosProducto/no-image.png",
      },
      loadingFotosProducto: false,
    };
  },
  mounted() {
    this.extraerFotos();
  },
  methods: {
    abrirDialogNuevaFotoProducto() {
      this.$store.state.tituloForm = "AGREGAR FOTO PRODUCTO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogFotoProducto.resetForm();
      this.$refs.dialogFotoProducto.setUpdateFoto(false);
      this.$refs.dialogFotoProducto.openDialog();
    },
    getProductoFoto(productoId, colorId) {
      let self = this;

      self.$store.state.loadingInfo.show = true;
      fotoProductoService
        .get(productoId, colorId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR PRODUCTO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";
          self.$refs.dialogFotoProducto.resetForm();
          self.fotoProducto = result;
          if (self.fotoProducto.urlFotoThumb === null) {
            self.fotoProducto.urlFotoThumb =
              self.$store.state.apiHost + "/Content/FotosProducto/no-image.png";
          } else {
            self.fotoProducto.urlFotoThumb =
              self.$store.state.apiHost + self.fotoProducto.urlFotoThumb;
          }
          self.$refs.dialogFotoProducto.setUpdateFoto(true);
          self.$refs.dialogFotoProducto.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteProductoFoto(productoId, colorId) {
      let self = this;

      self.$refs.confirm
        .open(
          "ELIMINAR FOTO",
          "¿Estás seguro de eliminar la foto del producto?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            fotoProductoService
              .delete(productoId, colorId)
              .then(() => {
                var i = self.fotosProducto.findIndex(
                  (obj) => obj.colorId == colorId
                );
                self.fotosProducto.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text = "Foto eliminada con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                self.operationFailed(e);
                console.log(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    extraerFotos() {
      let self = this;
      self.fotosProducto = [];
      self.loadingFotosProducto = true;

      fotoProductoService
        .getAll(self.producto.productoId)
        .then((result) => {
          self.fotosProducto = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingFotosProducto = false;
        });
    },
    onFotoProductoAdded(fotoProducto) {
      this.fotosProducto.push(fotoProducto);
    },
    onFotoProductoUpdated() {
      this.extraerFotos();
    },
  },
};
</script>
